import React from "react";
import Slider from "react-slick";
import Navbar from "../../../layout/Navbar";
import Footer from "../../../layout/Footer";
import CupolaImage from "../../../assets/Our Products/Refractory Bricks/Cupola Bricks/IMG_20190911_162419.jpg";
import dataSheetImg from "../../../assets/Our Products/Refractory Bricks/Cupola Bricks/data-fire-clay-bricks.png";
import Slider1 from "../../../assets/Our Products/Refractory Bricks/Cupola Bricks/cupola-1.jpeg";
import Slider2 from "../../../assets/Our Products/Refractory Bricks/Cupola Bricks/cupola-2.jpeg";
import Slider3 from "../../../assets/Our Products/Refractory Bricks/Cupola Bricks/cupola-3.jpeg";
import Slider4 from "../../../assets/Our Products/Refractory Bricks/Cupola Bricks/cupola-4.jpeg";
import Slider5 from "../../../assets/Our Products/Refractory Bricks/Cupola Bricks/cupola-5.jpeg";
import Slider6 from "../../../assets/Our Products/Refractory Bricks/Cupola Bricks/cupola-6.jpeg";
import Slider7 from "../../../assets/Our Products/Refractory Bricks/Cupola Bricks/cupola-7.jpeg";
import Slider8 from "../../../assets/Our Products/Refractory Bricks/Cupola Bricks/cupola-8.jpeg";
import Slider9 from "../../../assets/Our Products/Refractory Bricks/Cupola Bricks/cupola-9.jpeg";
import Slider10 from "../../../assets/Our Products/Refractory Bricks/Cupola Bricks/cupola-10.jpeg";


const Cupola_Bricks = () => {

  const sliderImages = [
    Slider1, Slider2, Slider3, Slider4, Slider5, Slider6, Slider7, Slider8, Slider9, Slider10
  ];

  // Responsive slider settings
  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1000,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: true,
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        }
      }
    ]
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />

      {/* About Fire Clay Bricks Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-2 gap-10 items-center">
          {/* Text Section */}
          <div>
            <h2 className="text-4xl font-bold text-gray-900 mb-6">
              About <span className="text-orange-600">Cupola Bricks</span>
            </h2>
            <p className="text-lg text-gray-700 leading-relaxed mb-4">
              JANTA Group is highly expert in manufacturing a wide range of Cupola Bricks which are available based on different diameters and sizes.These are also manufactured as per the customer’s requested sizes.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed mb-4">
              We manufacture these products using excellent grade raw materials with the usage of modern technique by our experienced team. We boast of ourselves for being one of the most reputed manufacturers.Our products are used in countries like USA, UK, Nigeria, Vietnam, India and many other places.
            </p>
          </div>

          {/* Image Section */}
          <div className="flex justify-center md:justify-end relative">
            <img
              src={CupolaImage}
              alt="Cupola Bricks"
              className="w-80 h-80 object-cover rounded-2xl shadow-2xl"
            />
          </div>
        </div>
      </section>

      {/* Data Sheet Section */}
      <section className="py-16 bg-gradient-to-br from-gray-900 to-gray-800 text-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl sm:text-4xl font-bold mb-10">
            Product Data Sheet for <span className="text-orange-500">Cupola Bricks</span>
          </h2>

          <div className="flex justify-center">
            <img
              src={dataSheetImg}
              alt="Cupola Bricks Data Sheet"
              className="rounded-1xl shadow-2xl border border-white/20 w-full sm:w-[80%] md:w-[70%] object-contain"
            />
          </div>
        </div>
      </section>

      {/* Area of Application Section */}
      <section className="py-16 bg-gray-100">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center">
            Area Of Application
          </h2>
          <ul className="list-disc list-inside text-lg text-gray-700 space-y-2">
            <li>Mjorly Used In Foundry</li>
            <li>Cast Iron Industries</li>
            <li>Steel Cast Industries</li>
          </ul>
        </div>
      </section>

      {/* Auto Image Slider Section */}
      <section className="py-8 sm:py-16 bg-[#0b032d] text-white relative overflow-hidden">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="relative flex justify-center overflow-hidden rounded-2xl">

            <div className="slider w-full sm:w-2/3 h-[260px] sm:h-[250px]">
              <div className="w-full">
                <Slider {...sliderSettings}>
                  {sliderImages.map((image, index) => (
                    <div key={index} className="px-2 sm:px-2">
                      <img
                        src={image}
                        alt={`Slide ${index + 1}`}
                        className="h-[260px] sm:h-[200px] lg:h-[250px] w-full object-contain rounded-lg shadow-md"
                      />
                    </div>
                  ))}
                </Slider>
              </div>
            </div>

          </div>
        </div>
      </section>


      <style jsx>{`
        @keyframes slide {
          0% { transform: translateX(0); }
          33% { transform: translateX(-260px); }
          66% { transform: translateX(-520px); }
          100% { transform: translateX(0); }
        }
        .animate-slide {
          animation: slide 8s infinite linear;
        }
      `}</style>

      <Footer />
    </div>
  );
};

export default Cupola_Bricks;
